import { SmallBusinessLeadInfo } from '@/application/smallBusiness/domain/SmallBusinessLeadInfo';
import { SmallBusinessRepository } from '@/application/smallBusiness/domain/SmallBusinessRepository';
import { UseCase } from '@/shared/application/UseCase';
import { SfApiResponse } from '@hfc/ui-core';

export class SendLeadInfoUseCase implements UseCase<SmallBusinessLeadInfo, SfApiResponse<void>> {

  private repository: SmallBusinessRepository;

  public constructor (repository: SmallBusinessRepository) {
    this.repository = repository;
  }

  public async run (leadInfo: SmallBusinessLeadInfo): Promise<SfApiResponse<void>> {
    return await this.repository.sendLeadInfo(leadInfo);
  }

}
